export const defaultStatusStrings: BasicStatusStrings = {
  activeStatusText: 'Active',
  preactiveStatusText: 'Preactive',
  terminatedStatusText: 'Terminated',
};

export interface BasicStatusStrings {
  activeStatusText: string;
  preactiveStatusText: string;
  terminatedStatusText: string;
}

export const determineStatusFromDates = (
  statusStrings: BasicStatusStrings,
  effectiveDate?: string,
  terminationDate?: string,
) => {
  const today = new Date().getTime();
  const effectiveDateTime: number = effectiveDate
    ? new Date(effectiveDate).getTime()
    : 0;
  const terminationDateTime: number = terminationDate
    ? new Date(terminationDate).getTime()
    : 0;

  return effectiveDateTime !== 0 && effectiveDateTime > today // Future
    ? statusStrings.preactiveStatusText
    : (effectiveDateTime && !terminationDateTime) ||
        (terminationDateTime !== 0 && terminationDateTime > today) // Present
      ? statusStrings.activeStatusText
      : terminationDateTime !== 0 && terminationDateTime < today // Past
        ? statusStrings.terminatedStatusText
        : '';
};

/**
 * Determine the status of a contract based on the status and termination date
 * @param status - status of the item (ie coverage)
 * @param terminationDate - termination date of the item
 * @param effectiveDate - effective date of the item
 * @param statusStrings - object containing the status strings for reference
 * @returns status of the item as current or exipired
 */
export const determineStatus = (
  status?: string,
  terminationDate?: string,
  effectiveDate?: string,
  statusStrings = defaultStatusStrings,
) =>
  status ||
  determineStatusFromDates(statusStrings, effectiveDate, terminationDate);
